export enum AppSettings {
    HEADER_LIBS = 'etisalat-headlibs/master.head.html',
    FOOTER_LIBS = 'etisalat-footerlibs/master.footerlibs.html',

    APPLICATION_HEADER_URL = '/system/wst/wst-top-nav-cons/master.body.html',
    APPLICATION_NAVIATION_URL = '/system/wst/wst-main-navigation/master.body.html',
    APPLICATION_FOOTER_URL = '/system/wst/wst-footer-qlinks/master.body.html',
    APPLICATION_QLINKS_FOOTER_URL = '',
    POSTPAID_POSTER_URL = '/buyget/buyget-hero-banner-postpaid-addons.jsp',
    PREPAID_POSTER_URL = '',
    VISITOR_LINE_POSTER_URL = '',
    CONTROL_LINE_POSTER_URL = '',
    E_LIFE_POSTER_URL = '',
    TV_POSTER_URL = '',
    CALLS_POSTER_URL = '',
    LOADER_COLOR = '#E00800',
    LOCAL_CURRENTCY = 'AED',
    RESET_FILTER = 'RESET',
    //SESSION
    SESSION_IDLE_TIME = 900,
    SESSION_KEEP_ALIVE_TIME = 15,

    //BUNDLE SETTINGS
    NAVIGATION_STATE = '',
    NO = '0',
    IS_APPLY_DEFAULT_FILTERS = 1,

    //ADDON_CATEGOIRES
    MY_ADDONS = 'cat690015',
    POSTPAID = 'cat550027',
    PREPAID = 'cat550028',
    VISITOR_LINE = 'cat550023',
    CONTROL_LINE = 'cat550022',
    E_LIFE = 'cat550031',
    TV = 'cat550030',
    CALLS = 'cat550029',

    HOME_BOUND = 'cat1040018',

    //ADDON_SUBCATEGORIES
    //DEVICE
    SMART_PHONE = 'cat550037',
    TABLETS = 'cat550038',

    //ACCESSORIES
    ACCESSORIES = 'cat550039',

    //POSTPAID
    FREEDOM = 'cat820016',
    NEW_POSTPAID = 'cat580020',
    PREMIUM_POSTPAID = 'cat580022',
    ETISALAT_SMART = 'cat600017',
    ETISALAT_EMIRATI = 'cat580021',
    FREEDOM_UNLIMITED = 'cat820015',

    SUB_VISITOR_LINE = 'cat550035',
    SUB_CONTROL_LINE = 'cat550036',

    //PREPAID
    SUB_PREPAID = 'cat550034',

    //OFFERS
    OFFERS = 'cat740023',

    //eLife
    INTENET_TV_TELEPHONE = 'cat550049',
    ELIFE_CATEGORY_NAME = 'INTENETTVTELEPHONE',

    //SMART_PAY_PLAN
    SMART_PAY_PLAN = '',
    ETISALAT_EBRIDGE_LITE = 'sku2090302',
    ETISALAT_EBRIDGE_PREIMUM = 'sku2090303',

    ERROR = 'Sorry, something went wrong. Please try again later.',
    ERROR_VAL_00015 = 'ERROR_RTF_VAL-00015',
    ADOBE_BACKUP_SCRIPT = 'https://assets.adobedtm.com/0d04dd99f59e/07c17e71a414/launch-c0f5c0b15947-development.min.js',
    IS_ACTIVITY_LOGGING_ENABLED = 'TRUE',
    IS_AECB_ENABLED = 'TRUE',
    POSTPAID_PREMIUM_PLAN_TYPE = 9,
    CMS_URL_NEW_FRAGMENTPATH = 'https://qanew.eand.ae/graphql/execute.json/consumer-bau',

    IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION = "TRUE",
    CHECK_PREMIUM_PRICE= "500",
    BNPL_TABBY_DISABLE = "FALSE",
    POSTPAID_SECURE_CHECKOUT = 'izx2ds',
    POSTPAID_DELIVERY_PRERERENCE = '8ox00p',
    POSTPAID_DELIVERY_REVIEW = 'xv44hr',
    POSTPAID_REVIEW_ORDER= '46k6uv',
    POSTPAID_SHIPPING = '4gor91',
    POSTPAID_SUCCESS_EVENT = 'jbeopr',

    ENABLE_OTP_AUTHERIZATION_CHECKEOUT = "true",
    LOAD_CHECKOUT_PROCESS = 'xv44hr',
    EDIT_CHECKOUT_PROCESS = '4gor91',
    REVIEW_CHECKOUT_PROCESS = '46k6uv',
    DEVICE_ON_LOAD_ADJUST_TOKEN = 'ku1wgn',
    DEVICE_ADD_TO_CART_ADJUST_TOKEN = '37jlqo',
    ADD_SHIPPING_ADDRESS_ADJUST_TOKEN = 'ompbsq',
    ADD_PAYMENT_METHOD_ADJUST_TOKEN = '3094aj',
    PURCHASE_SUCCESS_ADJUST_TOKEN = 'ab4slo',
    SIGN_IN_URL= '/ecare/d/auth'
}
export enum SubSection {
    PRIMARY_ACCOUNT = 'primary account',
    SECONDARY_ACCOUNT = 'secondary account',
  }

  export enum LoginType {
    FULL = 'full access',
    INDIVIDUAL = 'Individual access',
  }
  export enum ScreenName {
    OTPVERIFICATION = 'otp verification',
  }
  export enum CheckoutAnalyticsEventName {
    OTP_VERIFICATION_SCREEN = 'otp_verification_screen',
    OTP_VERIFICATION_SCREEN_RESEND = 'otp_verification_screen_resend',
    OTP_VERIFICATION_SCREEN_VERIFY_SUCCESS = 'otp_verification_screen_verify_success',
    OTP_VERIFICATION_SCREEN_VERIFY_FAIL = 'otp_verification_screen_verify_fail',
    OTP_VERIFICATION_SCREEN_CLOSE = 'otp_verification_screen_close',
  }
  export enum CheckoutAnalyticsInfo {
    OTP_SENT = 'OTP sent',
    RESEND_OTP = 'Resend OTP',
    MANUALLY_ENTERED_OTP = 'Manually entered OTP',
    CLOSE_OTP_POPUP = 'close OTP popup',
  }
